import CartePage from "./CartePage";
import { carteGourmande } from "../data/menus";

const HERO = "/glace.webp";

// Photos UNIQUEMENT de plats / boissons de la carte
const GALLERY = [
  "/cocktail-2.webp",
  "/pain-perdu.webp",
  "/cocktail-1.webp",
  "/milkshake.webp",
];

export default function CarteGourmandePage() {
  return (
    <CartePage
      data={carteGourmande}
      heroImg={HERO}
      galleryImgs={GALLERY}
      subtitleKey="gourmande"
      titleKey="gourmande"
      testid="page-carte-gourmande"
    />
  );
}
